import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Modal,
  Row,
  Col,
  Button,
  CloseButton,
  Form,
} from "react-bootstrap";
import "./PatientTaskModal.css";
import moment from "moment";
import async from "async";
import { useSelector } from "react-redux";
import AMEventModal from "./AMEventModal";
import HRMEventModal from "./HRMEventModal";
import { callApi, validateToken } from "../../../../../lib/utils";
import SelectField from "../../../../GenericComponents/SelectField";
import TaskNoteForm from "../../../../GenericComponents/TaskNotes/TaskNoteForm";
import CustomLoader from "../../../../GenericComponents/CustomLoader";

function PatientTaskModal({
  showModal,
  handleShowModal,
  modalData,
  taskType,
  isAMEvent,
}) {
  const fields = {
    eventDateTime: { title: "Event Date Time" },
    eventDuration: { title: "Event Duration" },
    eventSeverity: { title: "Event Severity" },
    longitude: { title: "Longitude" },
    latitude: { title: "Latitude" },
    eventStatus: { title: "Event Status" },
    newWeightLogged: { title: "New Weight Logged" },
    lastWeightLogged: { title: "Last Weight Logged" },
    weightReportedAt: { title: "Weight Reported At" },
    lastWeightReportedAt: { title: "Last Weight Reported At" },
    medicalVisitType: { title: "Medical Visit Type" },
    visitDateTime: { title: "Visit Date Time" },
    reason: { title: "Reason" },
    notes: { title: "Notes" },
  };
  const profileData = useSelector(
    (state) => state?.dashboard?.profileData?.patientData
  );
  const eventData = useSelector((state) => state?.dashboard?.eventTypeList);
  const currentEvent = eventData?.filter(
    (item) => item.id === modalData?.eventType
  );
  const [loading, setLoading] = useState(false);
  const [fileBlob, setBlobFile] = useState([]);
  const [noteTypes, setNoteTypes] = useState([]);
  const [eventClassification, setEventClassification] = useState("");
  const [hrmEvent, setHRMEvent] = useState([]);

  useEffect(() => {
    validateToken((err) => {
      if (err) {
        // console.log(err);
        window.location = "/logout";
      }
      setLoading(true);

      callApi(`/api/patient/note/types`, {}, "GET")
        .then((response) => {
          const temp = response?.data.data?.noteTypes.map((item) => {
            return { id: item.id, name: item.noteType };
          });
          setNoteTypes(temp);
          setLoading(false);
        })
        .catch((err) => {
          console.log("err: ", err);
          setLoading(false);
        });

      if (modalData.taskMetadata.eventType === "HRThreshold") {
        callApi(
          `/api/patient/events/${modalData.eventType}/${modalData.referenceId}`,
          {},
          "GET"
        ).then((response) => {
          let heartRateMonitoringEvent = response.data.data.heartRateMonitoringEvent;
          setHRMEvent(heartRateMonitoringEvent);
        }).catch((err) => {
          console.log("err: ", err);
          setLoading(false);
        });
      }
    })
  }, []);

  const getEventClassification = (status) => {
    setEventClassification(status);
  };

  const downlaodReport = () => {
    setLoading(true);
    axios({
      method: "get",
      url: `/upload/export/pdf/abnormal-motion/graph/${modalData.referenceId}`,
      responseType: "blob",
    })
      .then((response) => {
        var filename = "";
        let disposition = null;

        if (Object.keys(response.headers).includes("content-disposition")) {
          disposition = response.headers["content-disposition"];
        } else if (
          Object.keys(response.headers).includes("Content-Disposition")
        ) {
          disposition = response.headers["Content-Disposition"];
        }

        // var disposition = xhr.getResponseHeader('Content-Disposition');
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
        let blobData = response.data;
        setLoading(false);
        setBlobFile(blobData);
        fileDownload(filename, blobData);
        //fileDownload(response.data, id + ".xlsx");
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const fileDownload = (filename, blobData) => {
    var type = "";
    var blobURL = window.URL.createObjectURL(blobData);
    var tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute(
      "download",
      filename !== ""
        ? `${filename}`
        : type === "xlsx"
          ? "report.xlsx"
          : "report.pdf"
    );

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  };
  const getVisitDateTime = (param) => {
    const newDate = new Date(modalData.taskMetadata.visitDateTimeEpoch);
    return `${moment(newDate).tz(moment.tz.guess()).format("MM/DD/YYYY")}`
  }

  return (
    <div className="patient-task-modal-content">
      <CustomLoader loading={loading} />
      <Row id="Event-details">
        <Col md="12" sm="12" lg="8" className="tasks-details-container">
          <Row
            className={
              modalData?.taskMetadata?.eventType !== "AbnormalMotionEnd" &&
              "heading-container"
            }
          >
            <Col md={10}>
              <h5 id="lable-event">
                {currentEvent.length
                  ? currentEvent[0]?.eventName?.replace("End", "")
                  : ""}
                {modalData?.taskMetadata?.eventType === "AbnormalMotionEnd" ? (
                  <span
                    style={{ fontSize: "1rem" }}
                  >{`[ ${eventClassification} ]`}</span>
                ) : (
                  ""
                )}
              </h5>
              <p id="taskDetails" style={{ textTransform: "capitalize" }}>
                {modalData.taskDetails}
              </p>
            </Col>
            <Col md={2}>
              <div className="datetime-container">
                <div className="text-align-left">
                  {moment(modalData?.taskMetadata?.eventDateTimeEpoch).format("MM/DD/YYYY")}
                </div>
                <div className="text-align-left">
                  {moment(modalData?.taskMetadata?.eventDateTimeEpoch).format("hh:mm A")}
                </div>
              </div>
            </Col>
          </Row>
          {modalData?.taskMetadata?.eventType === "AbnormalMotionEnd" && (
            <Row className="download-container">
              <Col>
                <a
                  title="Click to download report"
                  style={{ cursor: "pointer" }}
                  onClick={downlaodReport}
                >
                  <i class="fa fa-download"></i>
                </a>
              </Col>
            </Row>
          )}
          <Row id="patient-details">
            <Col lg={8} md={8} sm={6} xs={6}>
              <h6>
                {profileData?.firstName} {"  "}
                {profileData?.lastName}
              </h6>
              <h6 style={{ textTransform: "uppercase" }}>
                {profileData?.city}, {profileData?.state} {profileData?.zipCode}
              </h6>
            </Col>
            <Col lg={4} md={4} sm={6} xs={6}>
              <h6 className="text-align-right">
                {" "}
                {modalData?.taskMetadata?.patientMobileNumber}
              </h6>
              <h6 className="text-align-right">
                {modalData?.taskMetadata?.email}
              </h6>
            </Col>
          </Row>
          <Row
            id="task-metadata"
            className="task-details-container"
            style={{ paddingTop: "26px" }}
          >
            {modalData?.taskMetadata?.eventType !== "AbnormalMotionEnd" && (
              <Col md={12}>
                <p style={{ textTransform: "uppercase" }}>
                  {modalData.helpText}
                </p>
              </Col>
            )}
            {modalData?.taskMetadata?.eventType !== "AbnormalMotionEnd" && Object.keys(hrmEvent).length === 0 &&
              Object.keys(fields).map((key) => {
                return modalData?.taskMetadata &&
                  modalData?.taskMetadata.hasOwnProperty(key) ? (
                  <Col md={12}>
                    <p>
                      {fields[key].title} : {key === 'visitDateTime' ? getVisitDateTime(modalData?.taskMetadata[key]) : modalData?.taskMetadata[key]}
                    </p>
                  </Col>
                ) : (
                  <></>
                );
              })}

            {modalData?.taskMetadata?.eventType !== "AbnormalMotionEnd" && Object.keys(hrmEvent).length > 0 &&
              <>
                <Col md={12}>
                  <p>
                    Min Heart Rate : {hrmEvent.minHeartRate} bpm
                  </p>
                </Col>
                <Col md={12}>
                  <p>
                    Max Heart Rate : {hrmEvent.maxHeartRate} bpm
                  </p>
                </Col>
                <Col md={12}>
                  <p>
                    Avg Heart Rate : {hrmEvent.avgHeartRate} bpm
                  </p>
                </Col>
                <Col>
                  <HRMEventModal
                    modalData={modalData}
                    hrmEvent={hrmEvent}
                  />
                </Col>
              </>
            }

            {modalData?.taskMetadata?.eventType === "AbnormalMotionEnd" && (
              <Col>
                <AMEventModal
                  modalData={modalData}
                  getEventClassification={getEventClassification}
                />
              </Col>
            )}
          </Row>
          {modalData?.taskMetadata?.eventType !== "AbnormalMotionEnd" && (
            <Row
              style={{
                padding: "30px",
                textAlign: "center",
                alignItems: "center",
              }}
            >
              <Col>
                {taskType !== "INFO" && (
                  <Button
                    style={{ marginRight: "20px" }}
                    className="btn btn-primary"
                    id="btn_inProgress"
                  >
                    {" "}
                    IN PROGRESS{" "}
                  </Button>
                )}
                {taskType === "TODO" && (
                  <Button className="btn-success" id="btn_completed">
                    COMPLETED
                  </Button>
                )}
              </Col>
            </Row>
          )}
        </Col>
        <TaskNoteForm
          data={modalData}
          noteTypes={noteTypes}
          noteModuleId={1}
          patientTaskId={null}
          heading={"EVENT NOTES"}
        />
      </Row>
    </div>
  );
}

export default PatientTaskModal;
